import { useQuery } from '@tanstack/react-query';
import {
  fetchProductCosts,
  fetchServiceCosts,
  fetchTenantCosts,
  type CostWindowParams,
} from '@/api/tenants';

const FIVE_MIN = 5 * 60 * 1000;

export function useTenantCosts(params: CostWindowParams) {
  return useQuery({
    queryKey: ['tenant-costs', params],
    queryFn: () => fetchTenantCosts(params),
    staleTime: FIVE_MIN,
  });
}

export function useProductCosts(tenantId: string | undefined, params: CostWindowParams) {
  return useQuery({
    queryKey: ['tenant-product-costs', tenantId, params],
    queryFn: () => fetchProductCosts(tenantId!, params),
    enabled: !!tenantId,
    staleTime: FIVE_MIN,
  });
}

export function useServiceCosts(
  tenantId: string | undefined,
  product: string | undefined,
  params: CostWindowParams,
) {
  return useQuery({
    queryKey: ['tenant-product-service-costs', tenantId, product, params],
    queryFn: () => fetchServiceCosts(tenantId!, product!, params),
    enabled: !!tenantId && !!product,
    staleTime: FIVE_MIN,
  });
}
